<template>
  <div class="d-flex flex-grow-1 pb-3">
    <v-menu
      v-model="openPicker"
      :close-on-content-click="false"
      transition="fade-transition"
      offset-y
      :min-width="!$vuetify.breakpoint.xs ? 'auto' : ''"
      :nudge-bottom="10"
      :nudge-right="30"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="monthAndYearFormatted"
          :disabled="disabled"
          prepend-icon="mdi-calendar-today"
          readonly
          solo-inverted
          hide-details
          dense
          v-bind="attrs"
          v-on="on"
        >
        </v-text-field>
      </template>
      <v-date-picker
        class="monthPicker"
        :class="{
          'd-flex': $vuetify.breakpoint.xs,
        }"
        v-show="openPicker"
        v-model="month"
        type="month"
        @change="openPicker = false"
        :month-format="formatMonth"
        :title-date-format="formatMonth"
        :allowed-dates="disableFutureMonths"
        scrollable
        color="primary"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    openPicker: false,
  }),

  computed: {
    disabled() {
      return this.$store.state.filters.paymentMonth.disabled;
    },
    monthAndYearFormatted() {
      const { year, month } = this.$store.getters.getMonthAndYearOfPayment;

      const date = new Date(year, month - 1, 1).toLocaleDateString("default", {
        year: "numeric",
        month: "long",
      });

      return this.capitalize(date);
    },
    month: {
      get() {
        return this.$store.state.filters.paymentMonth.value;
      },
      set(month) {
        this.$store.commit("setPaymentMonth", { value: month });
      },
    },
  },

  methods: {
    formatMonth(date) {
      const monthIndex = date.substr(5, 6) - 1;
      return this.getMonthName(monthIndex);
    },
    getMonthName(monthIndex) {
      const month = new Date(2023, monthIndex, 1).toLocaleString("default", {
        month: "long",
      });

      return this.capitalize(month);
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    disableFutureMonths(date) {
      const now = new Date();
      const monthDate = new Date(date);
      return now > monthDate;
    },
  },
};
</script>

<style>
.monthPicker .v-date-picker-table__current {
  pointer-events: none;
  color: grey !important;
  border: none;
}
</style>
